import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toolPermissonCheckedPipe',
})
export class ToolPermissonCheckedPipe implements PipeTransform {
  transform(selectedLicenses: string[], licenseCode: string): boolean {
    return selectedLicenses && selectedLicenses.length
      ? selectedLicenses.some((license) => license === licenseCode)
      : false;
  }
}
